import { withErrorBoundary } from '@sentry/react';
import React from 'react';
import { assets } from '../../assets';
import DefaultScreen from '../../components/containers/default-screen';
import MenuCard from '../../components/navigation/menu-card';
import { Fallback } from '../../components/utils/error-boundary';
import { Paths } from '../../navigation/paths';
import { useIntl } from 'react-intl';

const Profile = (): JSX.Element => {
  const intl = useIntl();
  return (
    <DefaultScreen
      background={assets.images.profile_bg}
      title={intl.formatMessage({ id: 'profilePage.title' })}
    >
      <div className="grid gap-3 grid-cols-1 md:grid-cols-2">
        <MenuCard
          title={intl.formatMessage({ id: 'profilePage.menu.personalData' })}
          description={intl.formatMessage({ id: 'profilePage.menu.personalDataDescription' })}
          image={assets.images.profile_personal_data}
          url={Paths.personal_data}
        />
        <MenuCard
          title={intl.formatMessage({ id: 'profilePage.menu.settings' })}
          description={intl.formatMessage({ id: 'profilePage.menu.settingsDescription' })}
          image={assets.images.profile_settings}
          url={Paths.settings}
        />
        <MenuCard
          title={intl.formatMessage({ id: 'profilePage.menu.notifications' })}
          description={intl.formatMessage({ id: 'profilePage.menu.notificationsDescription' })}
          image={assets.images.profile_notifications}
          url={Paths.notifications}
        />
      </div>
    </DefaultScreen>
  );
};

export default withErrorBoundary(Profile, { fallback: Fallback });
